import { render, staticRenderFns } from "./FormArticles.vue?vue&type=template&id=693de7c6&"
import script from "./FormArticles.vue?vue&type=script&lang=ts&"
export * from "./FormArticles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports